export default __webpack_public_path__ + "static/imda20191stprize2-b05e227406aabd3596b0b74b6623606d.jpg";